import { Conversations, ConversationsListApiParams } from '../../typings/chat';
import APIRequester from './APIRequester';
import { APIDefaultHeaders } from '../../typings/APIRequester';

/**
 * @name ChatSDK
 * @description SDK to make calls directly to Chat Service API
 *  based on https://git.naspersclassifieds.com/olxeu/u2u/chat/chat-service/-/blob/master/doc
 * @class
 */
export default class ChatSDK extends APIRequester {
  private baseUrl: string;

  private atlasHeaders: Record<string, string> = {
    'X-Client': 'MWEB',
  };

  public constructor(chatServiceUrl: string, defaultHeaders: APIDefaultHeaders) {
    super(defaultHeaders);
    this.baseUrl = `${chatServiceUrl}/api`;
  }

  /**
   * @name getConversations
   * @method
   * @public
   */
  public async getConversations(params: ConversationsListApiParams): Promise<Conversations> {
    const res = await this.fetchAPI(`${this.baseUrl}/conversations`, 'GET', params, {
      ...this.atlasHeaders,
    });

    return res.body;
  }
}
